import { render, staticRenderFns } from "./car-number.vue?vue&type=template&id=4f792ed3&scoped=true"
import script from "./car-number.vue?vue&type=script&lang=js"
export * from "./car-number.vue?vue&type=script&lang=js"
import style0 from "./car-number.vue?vue&type=style&index=0&id=4f792ed3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f792ed3",
  null
  
)

export default component.exports